export function loadVoncaFontAlternateGlyphs() {
  const TARGET_SELECTOR = '.font-vonca';

  function wrapAsInNode(node) {
    if (!node || node.nodeType !== Node.TEXT_NODE) return;
    const text = node.nodeValue;
    // Catching both 'a' and 'A' so it works even if CSS uppercases the text
    if (!/[aA]/.test(text)) return;

    const frag = document.createDocumentFragment();
    let last = 0;

    text.replace(/[aA]/g, (match, idx) => {
      if (idx > last) frag.appendChild(document.createTextNode(text.slice(last, idx)));
      const span = document.createElement('span');
      span.className = 'alt-A';
      span.textContent = match;
      frag.appendChild(span);
      last = idx + 1;
    });

    if (last < text.length) frag.appendChild(document.createTextNode(text.slice(last)));
    node.parentNode.replaceChild(frag, node);
  }

  function processRoot(root) {
    const walker = document.createTreeWalker(
      root,
      NodeFilter.SHOW_TEXT,
      {
        acceptNode(n) {
          const p = n.parentNode;
          if (!p) return NodeFilter.FILTER_REJECT;
          const tag = p.nodeName.toLowerCase();
          // skip scripts/styles and text already inside .alt-A
          if (tag === 'script' || tag === 'style' || (p.classList && p.classList.contains('alt-A'))) {
            return NodeFilter.FILTER_REJECT;
          }

          if (!n.nodeValue || !n.nodeValue.trim()) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      }
    );

    let node;
    while ((node = walker.nextNode())) wrapAsInNode(node);
  }

  document.querySelectorAll(TARGET_SELECTOR).forEach(processRoot);
}